import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {TimeTrackingSchedule} from 'main/stores/time_tracking';
import {User} from 'main/stores/users';

const STEP_CONFIG = {
  schedule_details: {fields: ['name', 'managers'], endpoint: endpoints.TIME_TRACKING.SCHEDULES.UPDATE_DETAILS},
  employees: {fields: ['employees'], endpoint: endpoints.TIME_TRACKING.SCHEDULES.UPDATE_EMPLOYEES},
  review: {fields: ['sendSchedulePublishedNotification'], endpoint: endpoints.TIME_TRACKING.SCHEDULES.COMPLETE}
};

class ScheduleEditFlowState {
  store = new DomainStore();
  match;
  history;

  schedule;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({match, history}) {
    this.match = match;
    this.history = history;
  }

  async load() {
    await this.store._compose([
      endpoints.TIME_TRACKING.SCHEDULES.with(this.match.params.id),
      endpoints.USERS.ACTIVE
    ]);

    this.schedule = new TimeTrackingSchedule(this.store._getSingle(types.TIME_TRACKING.SCHEDULE));
  }

  async onStepSubmitted({location}) {
    const success = await this.submitStep(location);

    if (success && location === 'review') {
      this.history.push('/schedules');
    }

    return success;
  }

  async submitStep(location) {
    const {fields, endpoint} = STEP_CONFIG[location];
    const schedule = this.schedule.pick(fields);
    const {model, errors} = await this.store.patch(
      endpoint.with(this.match.params.id),
      types.TIME_TRACKING.SCHEDULE,
      schedule
    );

    this.errors = errors;
    if (!model) return false;

    this.schedule.update(model);
    return true;
  }

  get availableManagers() {
    return this.store._getAll(types.USER).map(user => new User(user));
  }
}

export default ScheduleEditFlowState;
